import makeBossQuery from "@saleor/hooks/makeBossQuery";
import gql from "graphql-tag";

import { MallOrders, MallOrdersVariables } from "./types/MallOrders";

export const MallOrdersQuery = gql`
  query MallOrders($filter: MallOrderCountFilterInput) {
    mallOrderCount(filter: $filter) {
      data {
        mall_name
        order_count
      }
    }
  }
`;

export const useMallOrdersQuery = makeBossQuery<
  MallOrders,
  MallOrdersVariables
>(MallOrdersQuery);
